export default __webpack_public_path__ + "static/media/bg-mid.9415a43c.jpg";